import styles from "../../css/dist/index.module.css";

export const NotFound = () => {
  return (<div className={`${styles["container"]} ${styles["mx-auto"]} ${styles["flex-col"]} ${styles["h-full"]} ${styles["flex"]} ${styles["items-center"]} ${styles["justify-center"]}`}>
    <p className={`${styles["font-bold"]} ${styles["text-8xl"]}`}>404</p>
    <p>Page not found.</p>
  </div>);
};
